import Link from "next/link";
import React, { useState } from "react";
import { useParams } from "next/navigation";
import { ToastContainer } from "react-toastify";
import { MenuOverlayProps } from "./types";
import LanguageSwitcher from "components/LanguageSwitcher";
import { useTranslation } from "hooks/useTranslation";
import { configSelector } from "features/config/config.selectors";
import { useAppSelector } from "appHooks";
import "./index.scss";
import Loader from "shared/Loader";
import { clientSelector } from "features/client/client.selectors";

const MenuOverlay: React.FC<MenuOverlayProps> = ({ projects, active }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { locale } = useAppSelector(configSelector);
  const params = useParams();
  // Use URL-derived locale for Link hrefs to avoid SSR/client hydration mismatch
  const urlLocale = (params?.locale as string) ?? locale;
  const t = useTranslation();
  const { data: clientData } = useAppSelector(clientSelector);
  return (
    <div className={`menu-overlay ${active ? "active" : ""}`}>
      {isLoading ? (
        <Loader showOverlay />
      ) : (
        <div className="menu-container">
          <div className="menu-wrapper">
            <div className="menu-block">
              <Link href={`/${urlLocale}/gallery`}>
                {t("menuOverlay.gallery")}
              </Link>
            </div>
            <div className="menu-spacer"></div>
            <div className="menu-block">
              <Link href={`/${urlLocale}/regions`}>
                {t("menuOverlay.categories")}
              </Link>
            </div>
            <div className="menu-spacer"></div>
            <div className="menu-block">
              <Link href={`/${urlLocale}/cameras`}>
                {t("menuOverlay.cameras")}
              </Link>
            </div>
            <div className="menu-spacer"></div>
            <div className="menu-block">
              <Link href={`/${urlLocale}/news`}>{t("menuOverlay.news")}</Link>
            </div>
            <div className="menu-spacer"></div>
            <div className="menu-block">
              <Link href={`/${urlLocale}/tickets`}>
                {t("menuOverlay.support")}
              </Link>
            </div>

            <div className="menu-spacer"></div>
            <div className="lang-block">
              <LanguageSwitcher
                setIsLoading={(val: boolean) => setIsLoading(val)}
              />
            </div>
          </div>
          <div className="projects-list-wrapper">
            {clientData?.slug === "KingSalmanPark" && (
              <>
                <div className="menu-project-title menu-block">
                  <Link href={`/${urlLocale}/live-stream`}>
                    {t("menuOverlay.liveStream")}
                  </Link>
                </div>
                <div className="menu-spacer"></div>
              </>
            )}
            <div className="menu-project-title menu-block">
              <Link href={`/${urlLocale}/projects`}>
                {t("menuOverlay.projects")}
              </Link>
            </div>

            <div className="menu-spacer w-100"></div>
            <div className="prj-wrapper">
              <ul className="prj-list">
                {projects?.map((item, index) => (
                  <li key={index}>
                    <Link href={"/" + urlLocale + "/projects/" + item.id}>
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default MenuOverlay;
